<template>
  <div class="MainSiteNav">
    <MainSiteNavMobile v-bind="{ content }" class="mobile" />
    <MainSiteNavDesktop v-bind="{ content, setHasShade }" class="desktop" />
  </div>
</template>

<script>
import MainSiteNavDesktop from './Desktop/index.vue'
import MainSiteNavMobile from './Mobile/index.vue'

export default {
  components: {
    MainSiteNavDesktop,
    MainSiteNavMobile,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    setHasShade: {
      type: Function,
    },
  },
}
</script>

<style scoped>

.MainSiteNav {
  line-height: 1.4;
  font-weight: 400;
  font-size: 0.875rem;
}

.desktop {
  display: none;
}

@media (--screen-lg) {
  .mobile {
    display: none;
  }
  .desktop {
    display: block;
  }
}
</style>
